import { createAsyncThunk } from '@reduxjs/toolkit';

import { IMetaTag } from '.';
import {
  APIDataProvider,
  ApiPaths,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';

export interface IGetMetaTagByPath {
  path: string;
}

const apiDataProvider = new APIDataProvider();

export const getMetaTags = createAsyncThunk(
  'meta-tags/get',
  async (data: IGetMetaTagByPath) => {
    const response = await apiDataProvider.get<
      TApiResponse<TApiPaginationResponse<IMetaTag>>
    >(`${ApiPaths.metaTags}?path=${data.path}`);

    return response.data;
  }
);
